import { trpc } from '@/shared/api';
export const useInvalidateBusinessProfile = () => {
  const utils = trpc.useUtils();
  return () =>
    Promise.all([
      utils.users.getBusinessProfile.invalidate(),
      utils.payments.getBankTransferOption.invalidate(),
    ]);
};
